import dynamic from 'next/dynamic'
import qs from 'qs'
import { get } from '../../components/helpers/Api'
const Sales = dynamic(() => import('../../components/sales/Sales'))

const SalesPage = (props) => {
    return <Sales {...props} />
}

SalesPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    const values = qs.parse(paths[paths.length - 1].replace('market?', ''))

    values['search_page'] = false
    values['searchType'] = values['search_type']
        ? values['search_type']
        : 'sales'
    values['tab'] = values['tab'] ? values['tab'] : 'sales'

    if (values['collection'] && values['collection'] !== '*')
        values['collection_details'] = await get(
            'collection-minimal/' + values['collection'],
            'legacy',
        )

    return values
}

export default SalesPage
